import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';

const PrivacyPolicy: React.FC = () => {
  return (
    <Container className="my-5">
      <Row>
        <Col md={{ span: 10, offset: 1 }}>
          <h1 className="mb-4">Privacy Policy</h1>

          <p>Effective Date: July 23, 2025</p>

          <h4>1. Introduction</h4>
          <p>
            Legacy Insurance Network ("we", "our", or "us") is committed to protecting your privacy. This Privacy Policy explains how we collect, use, and safeguard your personal information when you visit our website or use our services.
          </p>

          <h4>2. Information We Collect</h4>
          <ul>
            <li><strong>Personal Information:</strong> Name, email address, phone number, postal address, and other contact details.</li>
            <li><strong>Insurance Information:</strong> Policy types, coverage needs, or any information submitted through inquiry forms.</li>
            <li><strong>Technical Data:</strong> IP address, browser type, device information, usage data, and cookies.</li>
          </ul>

          <h4>3. How We Use Your Information</h4>
          <ul>
            <li>To provide quotes and insurance services</li>
            <li>To communicate with you and respond to inquiries</li>
            <li>To personalize your experience</li>
            <li>To comply with legal and regulatory obligations</li>
            <li>To improve our website and services</li>
          </ul>

          <h4>4. Sharing of Information</h4>
          <p>
            We may share your information with:
          </p>
          <ul>
            <li>Licensed insurance agents and providers</li>
            <li>Service providers assisting in operations (e.g., hosting, analytics)</li>
            <li>Government authorities when legally required</li>
          </ul>

          <h4>5. Cookies and Tracking</h4>
          <p>
            We use cookies and similar tracking technologies to improve user experience and analyze traffic. You can control cookie preferences through your browser settings.
          </p>

          <h4>6. Data Retention</h4>
          <p>
            We retain your information only as long as necessary to fulfill the purposes outlined in this policy or as required by law.
          </p>

          <h4>7. Data Security</h4>
          <p>
            We implement appropriate technical and organizational safeguards to protect your personal information from unauthorized access, use, or disclosure.
          </p>

          <h4>8. Your Privacy Rights</h4>
          <p>
            Depending on your jurisdiction, you may have rights to access, correct, delete, or restrict the use of your personal data. Please contact us to exercise these rights.
          </p>

          <h4>9. Third-Party Links</h4>
          <p>
            Our website may contain links to third-party websites. We are not responsible for their privacy practices or content.
          </p>

          <h4>10. Children’s Privacy</h4>
          <p>
            Our services are not directed to individuals under the age of 13. We do not knowingly collect personal information from children.
          </p>

          <h4>11. Changes to This Policy</h4>
          <p>
            We may update this Privacy Policy from time to time. Updates will be posted on this page with a new effective date.
          </p>

          <h4>12. Contact Us</h4>
          <p>
            If you have questions or concerns about this Privacy Policy, please contact us:<br />
            <strong>Email:</strong> privacy.legal@LegacyInsuranceNetwork.com
          </p>
        </Col>
      </Row>
    </Container>
  );
};

export default PrivacyPolicy;
